import { useState } from "react";
import { useNavigate } from "react-router-dom";

const axios = require("axios").default;

function AddSet() {
  const navigate = useNavigate();
  const [setName, changeSetName] = useState("");
  const [serverError, setServerError] = useState("");
  const [spaceError, setSpaceError] = useState("");

  function createSet(e) {
    e.preventDefault();
    const token = localStorage.getItem("token");

    if (/\s/.test(setName)) {
      setSpaceError(
        "Set names cannot have spaces. Try using dashes like 'English-102'"
      );
    } else {
      axios
        .post("https://application-flashcards.herokuapp.com/api/sets/create", {
          token: token,
          setName: setName,
        })
        .then(function (response) {
          console.log(response);
          navigate(`/dashboard/set/${setName}`);
        })
        .catch(function (error) {
          console.log(error);
          setServerError(error.response.data.message);
        });
    }
  }

  function changeNameState(e) {
    changeSetName(e.target.value);
  }

  return (
    <div className="rounded-lg border-solid border border-slate-200 my-2 w-4/12 shadow-md p-2 mx-auto mt-24 xsm:mx-auto xsm:my-5 xsm:w-10/12 md:w-6/12">
      <h2 className="font-semibold text-2xl my-3">Add Set</h2>
      <form>
        <label for="set_name">Set Name:</label>
        <input
          className="w-full border border-grey-800 w-full mt-1 mb-3"
          id="set_name"
          type="text"
          onChange={changeNameState}
        />
        <div className="flex justify-end">
          <button
            className="w-2/12 text-white bg-red-400 border-solid border border-neutral-50 rounded p-1 hover:bg-red-500 xsm:w-3/12 md:w-4/12 xl:w-4/12"
            onClick={() => {
              navigate("/dashboard");
            }}
          >
            Back
          </button>
          <button
            className="w-2/12 text-white bg-green-400 border-solid border border-neutral-50 rounded p-1 hover:bg-green-500 xsm:w-3/12 md:w-4/12 xl:w-4/12"
            type="submit"
            onClick={createSet}
          >
            Submit
          </button>
        </div>
      </form>
      {serverError ? (
        <p className="text-red-500 my-2 text-center">{serverError}</p>
      ) : null}
      {spaceError ? (
        <p className="text-red-500 my-2 text-center">{spaceError}</p>
      ) : null}
    </div>
  );
}

export default AddSet;
